import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://zepcvtrxyfjqqnbaxrew.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InplcGN2dHJ4eWZqcXFuYmF4cmV3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE5OTkwOTgsImV4cCI6MjA1NzU3NTA5OH0.TyIRcbcjXBAa6OUSPMxPBaMXAn93sCDvvAVv2tOjmTM';

// Create a single instance of the Supabase client to be used throughout the app
export const supabase = createClient(supabaseUrl, supabaseKey); 